<div class="mat-elevation-z8 py-2 overflow-auto scroll-div" style="overflow: auto;">

  @if (metadata && metadata.dataSource && metadata.dataSource.data.length > 0 && !!metadata.isLoaded) {
    <table class="uw-table" mat-table [dataSource]="metadata.dataSource" matSort
      (matSortChange)="sortChange.emit($event)">
      <!-- Dynamic Column Definition -->
      @for (column of nonActionColumns; track column) {
        <ng-container [matColumnDef]="column.columnDef">
          <th mat-header-cell [ngClass]="column.columnSize ? getColumnClass(column.columnSize) : ''" *matHeaderCellDef
          mat-sort-header>{{ column.header | translate }}</th>
          <td mat-cell *matCellDef="let element">
            @if (columnTemplates[column.columnDef]; as template) {
              <ng-container *ngTemplateOutlet="template; context: { $implicit: element }"></ng-container>
            }
            <ng-template #defaultCell>{{ element[column.columnDef] }}</ng-template>
          </td>
        </ng-container>
      }
      <!-- -Action Column -->
      @if (actionsColumn) {
        <ng-container [matColumnDef]="actionsColumn.columnDef">
          <th mat-header-cell *matHeaderCellDef class="uw-table-action-buttons"></th>
          <td mat-cell *matCellDef="let element">
            @if (element.hasActions) {
              <button class="ml-3" mat-icon-button [matMenuTriggerFor]="menu"
                [attr.aria-label]="'Row actions' | translate">
                <mat-icon>more_vert</mat-icon>
              </button>
            }
            <mat-menu #menu="matMenu">
              @if (columnTemplates[actionsColumn.columnDef]; as template) {
                <ng-container *ngTemplateOutlet="template; context: { $implicit: element }"></ng-container>
              }
            </mat-menu>
          </td>
        </ng-container>
      }
      <!-- Table Header & Row -->
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"
      [class.selected]="selectedRow && selectedRow[metadata.selectedRowIdentifier?.property] === row[metadata.selectedRowIdentifier?.property]"></tr>
    </table>
    <mat-paginator [length]="length" [pageIndex]="pageIndex" [pageSize]="pageSize" (page)="pageChange.emit($event)"
      [pageSizeOptions]="[10, 20, 30]" showFirstLastButtons [attr.aria-label]="">
    </mat-paginator>
  }

  <!--No Data Container-->
  @if (metadata && (!metadata.dataSource || !metadata.dataSource.data || (metadata.dataSource.data.length==0)) && !!metadata.isLoaded) {
    <app-no-record-container
      message="{{ 'messages.no_data_found' | translate }}">
    </app-no-record-container>
  }

</div>